import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import { mCPF, mCEP, mCNPJ } from '../utils/masks'
import { colors } from '../utils/vars'
import FrDatePicker from '../components/FrDatePicker'
import consultaCep from '../services/consultaCep'

import api from '../services/api'
import { getUserCode } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import { validarCNPJ, validarCPF } from '../utils/functions';
import FrLoading from '../components/FrLoading'

const swal = withReactContent(Swal)

function Clientes(props) {
  const [data, setData] = useState({ tipo: 11 })
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('S')
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])
  const [comboSexo, setComboSexo] = useState([{ value: 'F', display: 'Feminino' }, { value: 'M', display: 'Masculino' }])
  const [invalido, setInvalido] = useState(false)
  const [nomeEmp, setNomeEmp] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      setComboCid(await api.getComboData('cidades'))
      const auxValues = { ...data };
      api.get('/empresas?pk_emp=' + props.fk_emp).then(r => {

        setNomeEmp(r.data[0].razao_social)
        setData(auxValues)
      })

    }

    fetchData()
  }, [])



  function consistData(data) {
    let required = [
      'nome',
      'cpf',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr

      if ((!data[curr]) && (fieldName !== '')) return errors.push(fieldName)
    })

    return errors
  }


  function handleSubmit(e) {
    e.preventDefault();

    swal.fire({
      customClass: {
        container: 'my-swal'
      },

      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.fk_usu = getUserCode()
        let errors = consistData(auxValues, e)
        if (errors.length === 0) {
          try {
            api.post('/clientes/addCliente', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  customClass: {
                    container: 'my-swal'
                  },

                  title: `<p style='color:${colors.info900}'Registro Adicionado</p>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi adicionado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result) {
                    if (props.teste) {
                      props.setShowModal(false)
                      props.teste(r.data)
                    }
                  }
                })
              } else {
                swal.fire({
                  customClass: {
                    container: 'my-swal'
                  },

                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          } catch {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              text: "O registro não foi adicionado!",
              icon: 'warning',
            })

          }

        }
        else {
          if (errors.length > 0) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              html: <p style={{ color: colors.info900 }}>Verifique {errors.length > 1 ? 'os campos' : 'o campo'} {errors.join(', ')}</p>,
              icon: 'warning',
            })

          } else if (invalido) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Documento inválido!</h2>`,
              html: <p style={{ color: colors.info900 }}>Verifique o CPF/CNPJ</p>,
              icon: 'warning',
            })
          }
        }
      }
    })
  }


  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      customClass: {
        container: 'my-swal'
      },

      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result) {
        if (props.modal)
          props.setShowModal(false)
        else
          window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };

    switch (e.target.name) {

      case 'nome': auxValues[e.target.name] = e.target.value.toUpperCase();
        // if (props.modal)
        // props.setNome(e.target.value)
        break

      default: auxValues[e.target.name] = e.target.value.toUpperCase();

    }

    setData(auxValues);
  };


  const validaCpfCnpj = async (e) => {
    e.preventDefault()
    const auxValues = { ...data };

    let value = e.target.value
    setInvalido(false)

    if ((value) && (!validarCPF(value))) {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },
        title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
        html: `<p style='color: ${colors.info900}'>CPF Inválido</p>`,
        icon: 'warning',
      }).then(r => {
        setInvalido(true)
        document.getElementById('cpf').focus()
      })
    }
    else {
      await api.get('/clientes?cpf=' + value).then(r => {
        if (r.data.length > 0) {
          auxValues.nome = r.data[0].nome
          auxValues.data_nascimento = r.data[0].data_nascimento
          auxValues.genero = r.data[0].genero
          auxValues.rg = r.data[0].rg

          setData(auxValues)
        }
      })
    }
  }

  const handleCep = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    if (e.target.name == 'cep') {
      consultaCep((e.target.value).replace('.', '').replace('-', '') + '/json').then(r => {
        if (!r.data.erro) {
          auxValues.endereco = r.data.logradouro
          auxValues.complemento = r.data.complemento
          auxValues.bairro = r.data.bairro
          api.get('/cidades?descricao=' + r.data.localidade).then(res => {
            if (res.data.length > 0) {
              auxValues.fk_cid = res.data[0].pk_cid
            }
            setData(auxValues)
            swal.close()
          })
        } else {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },

            title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
            html: `<p style='color: ${colors.info900}'>CEP Inválido</p>`,
            icon: 'warning',
          })
        }
      })

    }
  }


  return (
    <div className="defaultReg">
      {!props.modal ? <NavBar /> : <></>}
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>Inclusão de Cliente - Empresa {nomeEmp}</h3>

          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />

        <form id="regForm" onSubmit={handleSubmit}>
          <FrTextInput
            maxLength='18'
            value={data.tipo > 14 ? mCNPJ(data.cpf) : mCPF(data.cpf)}
            onChange={handleChange}
            name="cpf"
            id="cpf"
            color="#389492"
            label={data.tipo > 14 ? "CNPJ" : "CPF"}
            variant="outlined"
            size="small"
            onBlur={validaCpfCnpj}
            required
            style={{ width: 160 }}
            autoFocus
          />

          <FrTextInput
            maxLength='100'
            value={data.nome || ''}
            onChange={handleChange}
            name="nome"
            id="nome"
            color="#389492"
            label={data.tipo > 14 ? 'Nome Fantasia' : "Nome"}
            variant="outlined"
            size="small"
            required
            style={{ width: 420 }}
          />

          <FrSelect
            value={data.genero || ''}
            onChange={handleChange}
            name="genero"
            id="genero"
            label='Sexo'
            data={comboSexo}
            style={{ width: 120 }}
          />

          <FrTextInput
            maxLength='20'
            value={data.rg || ''}
            onChange={handleChange}
            name="rg"
            id="rg"
            color="#389492"
            label="RG"
            variant="outlined"
            size="small"
            style={{ width: 270 }}
          />

          <FrDatePicker
            name="data_nascimento"
            id="data_nascimento"
            color="#389492"
            label="Data de Nascimento"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
            value={(data.data_nascimento || '').split("T")[0]}
            onChange={handleChange}
          />

          <br />
          <FrTextInput
            maxLength='10'
            value={data.cep ? mCEP(data.cep) : ''}
            onChange={handleChange}
            name="cep"
            id="cep"
            color="#389492"
            label="CEP"
            variant="outlined"
            size="small"
            style={{ width: 110 }}
            onBlur={handleCep}
          />

          <FrTextInput
            maxLength='100'
            value={data.endereco || ''}
            onChange={handleChange}
            name="endereco"
            id="endereco"
            color="#389492"
            label="Endereço"
            variant="outlined"
            size="small"
            style={{ width: 450 }}
          />

          <FrTextInput
            maxLength='5'
            value={data.numero || ''}
            onChange={handleChange}
            name="numero"
            id="numero"
            color="#389492"
            label="Número"
            variant="outlined"
            size="small"
            style={{ width: 100 }}
          />

          <FrTextInput
            maxLength='20'
            value={data.complemento || ''}
            onChange={handleChange}
            name="complemento"
            id="complemento"
            color="#389492"
            label="Complemento"
            variant="outlined"
            size="small"
            style={{ width: 120 }}
          />
          <FrTextInput
            maxLength='100'
            value={data.bairro || ''}
            onChange={handleChange}
            name="bairro"
            id="bairro"
            color="#389492"
            label="Bairro"
            variant="outlined"
            size="small"
            style={{ width: 250 }}
          />

          <FrSelect
            value={data.fk_cid || ''}
            onChange={handleChange}
            name="fk_cid"
            id="fk_cid"
            label='Cidade'
            data={comboCid}
            style={{ width: 200 }}
          />

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        {!props.modal ? <FooterDelphus /> : <></>}
      </div>
    </div>
  );
}

export default Clientes;
